import { NEARBY_TRANSFER_STATES } from "./nearbyTransfer.constants";

export const NEARBY_TRANSFER_ACTIONS = Object.freeze({
  CONNECTING: "connecting",
  SOCKET_OPEN: "socketOpen",
  SOCKET_CLOSED: "socketClosed",
  SET_DEVICES: "setDevices",
  REQUEST_PAIR: "requestPair",
  INCOMING_PAIR: "incomingPair",
  PAIRING: "pairing",
  SET_PAIRING_CODE: "setPairingCode",
  SET_CONNECTED: "setConnected",
  SET_PEER_READY: "setPeerReady",
  SET_TRANSFER_PROGRESS: "setTransferProgress",
  SET_RECEIVED_TRANSFER: "setReceivedTransfer",
  CLEAR_RECEIVED_TRANSFER: "clearReceivedTransfer",
  DISCONNECT: "disconnect",
  FAIL: "fail",
});

export const initialNearbyTransferState = Object.freeze({
  status: NEARBY_TRANSFER_STATES.CONNECTING,
  devices: [],
  isSocketConnected: false,
  isChannelConnected: false,
  isPeerReady: false,
  pendingPairRequest: null,
  incomingPairRequest: null,
  connectedDevice: null,
  pairingCode: "",
  transferProgress: 0,
  receivedTransfer: null,
  errorMessage: "",
});

const getIdleStatus = (state) =>
  state.isSocketConnected
    ? NEARBY_TRANSFER_STATES.DISCOVERING
    : NEARBY_TRANSFER_STATES.OFFLINE;

const hasActivePairing = (state) =>
  [
    NEARBY_TRANSFER_STATES.REQUESTING_PAIR,
    NEARBY_TRANSFER_STATES.INCOMING_PAIR,
    NEARBY_TRANSFER_STATES.PAIRING,
  ].includes(state.status);

const setSocketOpen = (state) => ({
  ...state,
  isSocketConnected: true,
  status: state.isChannelConnected
    ? state.status
    : NEARBY_TRANSFER_STATES.DISCOVERING,
  errorMessage: "",
});

const setDevices = (state, devices) => ({
  ...state,
  devices,
  status: state.isChannelConnected || hasActivePairing(state)
    ? state.status
    : NEARBY_TRANSFER_STATES.DISCOVERING,
});

const setConnected = (state, action) => ({
  ...state,
  status: NEARBY_TRANSFER_STATES.CONNECTED,
  isChannelConnected: true,
  pendingPairRequest: null,
  incomingPairRequest: null,
  connectedDevice: action.connectedDevice ?? state.connectedDevice,
  pairingCode: action.pairingCode ?? state.pairingCode,
  transferProgress: 0,
  errorMessage: "",
});

export const nearbyTransferReducer = (state, action) => {
  switch (action.type) {
    case NEARBY_TRANSFER_ACTIONS.CONNECTING:
      return {
        ...state,
        status: state.isChannelConnected
          ? state.status
          : NEARBY_TRANSFER_STATES.CONNECTING,
      };
    case NEARBY_TRANSFER_ACTIONS.SOCKET_OPEN:
      return setSocketOpen(state);
    case NEARBY_TRANSFER_ACTIONS.SOCKET_CLOSED:
      return {
        ...state,
        devices: [],
        isSocketConnected: false,
        isChannelConnected: false,
        isPeerReady: false,
        pendingPairRequest: null,
        incomingPairRequest: null,
        connectedDevice: null,
        pairingCode: "",
        transferProgress: 0,
        status: NEARBY_TRANSFER_STATES.OFFLINE,
      };
    case NEARBY_TRANSFER_ACTIONS.SET_DEVICES:
      return setDevices(state, action.devices);
    case NEARBY_TRANSFER_ACTIONS.REQUEST_PAIR:
      return {
        ...state,
        status: NEARBY_TRANSFER_STATES.REQUESTING_PAIR,
        pendingPairRequest: action.pairRequest,
        incomingPairRequest: null,
        errorMessage: "",
      };
    case NEARBY_TRANSFER_ACTIONS.INCOMING_PAIR:
      return {
        ...state,
        status: NEARBY_TRANSFER_STATES.INCOMING_PAIR,
        pendingPairRequest: null,
        incomingPairRequest: action.pairRequest,
        errorMessage: "",
      };
    case NEARBY_TRANSFER_ACTIONS.PAIRING:
      return {
        ...state,
        status: NEARBY_TRANSFER_STATES.PAIRING,
        pendingPairRequest: null,
        incomingPairRequest: null,
        connectedDevice: action.connectedDevice ?? state.connectedDevice,
        errorMessage: "",
      };
    case NEARBY_TRANSFER_ACTIONS.SET_PAIRING_CODE:
      return { ...state, pairingCode: action.pairingCode };
    case NEARBY_TRANSFER_ACTIONS.SET_CONNECTED:
      return setConnected(state, action);
    case NEARBY_TRANSFER_ACTIONS.SET_PEER_READY:
      return { ...state, isPeerReady: true };
    case NEARBY_TRANSFER_ACTIONS.SET_TRANSFER_PROGRESS:
      return {
        ...state,
        status: NEARBY_TRANSFER_STATES.TRANSFERRING,
        transferProgress: action.transferProgress,
      };
    case NEARBY_TRANSFER_ACTIONS.SET_RECEIVED_TRANSFER:
      return {
        ...state,
        status: NEARBY_TRANSFER_STATES.CONNECTED,
        receivedTransfer: action.receivedTransfer,
        transferProgress: 100,
      };
    case NEARBY_TRANSFER_ACTIONS.CLEAR_RECEIVED_TRANSFER:
      return { ...state, receivedTransfer: null };
    case NEARBY_TRANSFER_ACTIONS.DISCONNECT:
      return {
        ...state,
        status: getIdleStatus(state),
        isChannelConnected: false,
        isPeerReady: false,
        pendingPairRequest: null,
        incomingPairRequest: null,
        connectedDevice: null,
        pairingCode: "",
        transferProgress: 0,
        receivedTransfer: null,
      };
    case NEARBY_TRANSFER_ACTIONS.FAIL:
      return {
        ...state,
        status: NEARBY_TRANSFER_STATES.FAILED,
        isChannelConnected: false,
        isPeerReady: false,
        errorMessage: action.errorMessage,
      };
    default:
      return state;
  }
};
